import React from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./App.scss";

import { ChangeLanguage } from "../../resources/i18n/i18n";
import { APP_LANGUAGES, URL_FILTER, MANAGE_SESSION } from "../../constants/appConstants";

import { initializeInterceptors } from "../../config/AxiosInterceptor";

import { logoutAction } from "../Login/LoginAction";
import { setSearchFilterAction } from "../../constants/Action";
import { ROUTES, PUBLIC_ROUTES } from "../../constants/routeConstants";
import { OPERATION_STATUS } from "../../config/axios.init";

class App extends React.Component {
  constructor(props) {
    super(props);
    if (window.performance) {
      if (
        window.performance &&
        window.performance.getEntriesByType("navigation") &&
        window.performance.getEntriesByType("navigation")[0] &&
        window.performance.getEntriesByType("navigation")[0].type ===
        "reload"
      ) {
        if (
          Object.keys(URL_FILTER).includes(
            props.history.location.pathname
          )
        ) {
          props.setSearchFilterAction(
            URL_FILTER[props.history.location.pathname].key,
            URL_FILTER[props.history.location.pathname].filter
          );
        }
        if ((!localStorage.getItem("state")
          || !JSON.parse(localStorage.getItem("state")).loginReducer.loggedInUserInfo.userId)
          && props.history.location.pathname !== ROUTES.LOGIN
          && !PUBLIC_ROUTES.includes(props.history.location.pathname)) {
          props.history.push("/ingreso");
        }
      }
    }
    initializeInterceptors(props.history, this.logoutAction);
  }

  logoutAction = (callback) => {
    this.props.logoutAction(callback);
  };
  componentDidMount() {
    this.channel = new BroadcastChannel('my_channel');
    const myTabId = Date.now();  // Unique tab ID
    let ackReceived = false;

    this.channel.onmessage = (event) => {
      const { type, tabId } = event.data;
      if (type === MANAGE_SESSION.CHECK_OTHER_TAB && tabId !== myTabId) {
        this.channel.postMessage({ type: MANAGE_SESSION.TAB_ACKNOWLEDGE, tabId: myTabId });
      }
      if (type === MANAGE_SESSION.TAB_ACKNOWLEDGE && tabId !== myTabId) {
        ackReceived = true;
        sessionStorage.setItem("isUserLogged", true)
      }
    };
    this.channel.postMessage({ type: MANAGE_SESSION.CHECK_OTHER_TAB, tabId: myTabId });
    setTimeout(() => {
      if (sessionStorage.getItem("isUserLogged") === null && !ackReceived
        && !PUBLIC_ROUTES.includes(this.props.history.location.pathname)) {
        this.logoutAction((apiResponse) => {
          if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
            this.props.history.push(ROUTES.LOGIN);
          }
        })
      }
    }, 500);
    ChangeLanguage(APP_LANGUAGES.SPANISH);
  }

  componentWillUnmount() {
    this.channel.close()
    window.removeEventListener('beforeunload', this.logoutAction);
  }


  render() {
    return (
      <div className='app'>
        <div className='mainContent'>{this.props.children}</div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({}); //NOSONAR
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { logoutAction, setSearchFilterAction },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(App));
